/**
 * Brand marks. The gold wordmark and the temple icon are static PNGs in
 * public/ (optimized from the source art in /Logos). Callers set the height via
 * className (e.g. "h-7 w-auto"); the gold artwork reads on both the light
 * editorial and the dark video surfaces, so no per-surface variant is needed.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/logo-wordmark.png"
      alt="ArcheTelos"
      width={1200}
      height={185}
      className={className}
    />
  );
}

/** The temple emblem — the compact mark for tight slots (collapsed sidebar, exits). */
export function LogoIcon({ className }: { className?: string }) {
  return (
    <img src="/logo-icon.png" alt="ArcheTelos" width={256} height={256} className={className} />
  );
}
